import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadCentersByFranchisee } from './actions';
import List from './List';
import { Panel } from 'react-bootstrap';
import authUtils from '../../auth/utils';

class Centers extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const franchiseeId = this.props.franchiseeId;
		this.props.loadData({ franchiseeId, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleListEvent(listPagination) {
		const franchiseeId = this.props.franchiseeId;
		this.props.loadData({ franchiseeId, ...listPagination });
	}

	render() {
		return <Panel>
			<Panel.Body>
				<List franchiseeId={this.props.franchiseeId} onFetchData={this.handleListEvent} data={this.props.data} allowNew={this.props.allowNew} {...this.props.pagination} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		entities: { centers },
		auth: { currentUser }
	} = state;

	const centersPagination = pagination.centersByFranchisee[ownProps.franchiseeId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: centersPagination.ids.map(id => centers[id]),
		pagination: centersPagination,
		allowNew: !authUtils.hasReadOnlyPermission(currentUser, 'Franchisees') && !currentUser.isCenterRestricted,

	};
};

Centers.propTypes = {
	franchiseeId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadCentersByFranchisee
})(Centers);